// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?PanicButton!../../src/app/panic_button');
